export enum ScannerWorkflow {
  StageEquipmentForJob = 'stage_equipment_for_job',
  ShipEquipmentToJobSite = 'ship_equipment_to_job_site',
  ShipEquipmentToGeckoOffice = 'ship_equipment_to_gecko_office',
  ReceiveEquipmentFromJob = 'receive_equipment_from_job',
  ReceiveEquipmentFromGeckoOffice = 'receive_equipment_from_gecko_office',
  ReceiveEquipmentFromThirdParty = 'receive_equipment_from_third_party',
}

export const getScannerWorkflow = (value: string) => {
  if (Object.values(ScannerWorkflow).includes(value as ScannerWorkflow)) {
    return value as ScannerWorkflow
  }
  return ScannerWorkflow.ReceiveEquipmentFromJob
}

export const getScannerWorkflowLabel = (workflow: ScannerWorkflow): string => {
  const labels: Record<ScannerWorkflow, string> = {
    [ScannerWorkflow.StageEquipmentForJob]: 'Stage Equipment for Job',
    [ScannerWorkflow.ShipEquipmentToJobSite]: 'Ship Equipment to Job Site',
    [ScannerWorkflow.ShipEquipmentToGeckoOffice]:
      'Ship Equipment to Gecko Office',
    [ScannerWorkflow.ReceiveEquipmentFromJob]: 'Receive Equipment from Job',
    [ScannerWorkflow.ReceiveEquipmentFromGeckoOffice]:
      'Receive Equipment from Gecko Office',
    [ScannerWorkflow.ReceiveEquipmentFromThirdParty]:
      'Receive Equipment from 3rd Party',
  }
  return labels[workflow] ?? workflow
}
